import { useTranslation } from 'src/core/common/hooks/useTranslation';
import type { InvoiceInconsistencyItem } from 'src/core/modules/verification-of-payee/models';

export const InvoiceInconsistencyItemSummary = ({
  item,
}: {
  item: InvoiceInconsistencyItem;
}) => {
  const { t } = useTranslation('global');

  return (
    <div className="flex items-center gap-8">
      <span className="text-content-secondary-bg-secondary body-m">
        {item.accountHolderName}
      </span>
      <div className="border-border-default h-24 w-px border-l" />
      <span className="text-content-secondary-bg-secondary body-m">
        {t('inconsistencyModal.invoice.count', { count: item.invoiceCount })}
      </span>
    </div>
  );
};
